import { Typography, Button } from "@mui/material";
import { alpha } from '@mui/material/styles';
import { Close } from "@mui/icons-material";
import { tss } from "tss-react/mui";
import commonStyles, { panelHeaderHeight, panelBackgroundColor, labelColor } from "styles/common";

const useStyles = tss.create(({theme}) => ({
    root: {
        display: "flex",
        height: panelHeaderHeight,
        width: "100%",
        background: alpha(theme.palette.background.paper, 0.75)
    },
    title: {
        display: "inline-flex",
        position: "relative",
        left: 12,
        width: 190,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        alignItems: "center",
        color: theme.palette.text.primary,
        fontSize: 14,
        letterSpacing: "0.1px",
        lineHeight: "16px",
    },
    rightDiv: {
        position: "absolute",
        right: 2,
        top: 7,
        userSelect: "none",
    },
    button: {
        width: 16,
        height: 16,
        minWidth: 16,
        margin: "8px 4px 0 8px",
        position: "absolute",
        right: 6,
    },
}));

type IProps = {
    title: string;
    icon?: any;
    handleClose: () => void;
};

export default function PanelHeader(props: IProps) {
    const { classes: common } = commonStyles();
    const { classes } = useStyles();
    const { title, icon, handleClose } = props;
    return (
        <div className={classes.root}>
            {icon}
            <Typography className={classes.title}> {title}</Typography>
            <div className={classes.rightDiv}>
                <Button className={classes.button} onClick={handleClose}>
                    <Close className={common.closeButton} />
                </Button>
            </div>
        </div>
    );
}
